import { render, staticRenderFns } from "./DatasetTextEditor.vue?vue&type=template&id=2d856368&scoped=true"
import script from "./DatasetTextEditor.vue?vue&type=script&lang=js"
export * from "./DatasetTextEditor.vue?vue&type=script&lang=js"
import style0 from "./DatasetTextEditor.vue?vue&type=style&index=0&id=2d856368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d856368",
  null
  
)

export default component.exports